<template>
  <div class="tva-viz-paragraph-component">
    <div v-if="!content.img">
      <div class="tva-row">
        <p
          class="title tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-1 tva-col-md-10"
        >{{content.title}}</p>
      </div>
      <div class="tva-row">
        <p
          class="paragraph tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-1 tva-col-md-10"
          v-html="content.text"
        >{{content.text}}</p>
      </div>
      <div class="tva-row" v-if="content.img_full">
        <img
          class="image-full tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-1 tva-col-md-10"
          :src="`${baseUrl}images/${content.img_full}${$tvaMq === 'mobile' ? '_m' : ''}.svg`"
        >
      </div>
    </div>
    <div v-if="content.img && $tvaMq !== 'mobile'" class="tva-row">
      <p
        class="paragraph tva-col-xs-offset-1 tva-col-xs-10 tva-col-sm-offset-1 tva-col-sm-4 tva-col-md-offset-1 tva-col-md-4"
      >
        <span class="title">{{content.title}}</span>
        <br>
        {{content.text}}
      </p>
      <img
        class="tva-col-xs-offset-1 tva-col-xs-10 tva-col-sm-offset-0 tva-col-sm-6 tva-col-md-offset-1 tva-col-md-5"
        :src="`${baseUrl}images/${content.img}${$tvaMq === 'mobile' ? '_m' : ''}.svg`"
      >
    </div>
    <div v-if="content.img && $tvaMq === 'mobile'">
      <div class="tva-row">
        <p class="paragraph tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-1 tva-col-md-10">
          <span class="title">{{content.title}}</span>
          <br>
          {{content.text}}
        </p>
      </div>
      <div class="tva-row column-image">
        <img
          class="image tva-col-sm-offset-2 tva-col-sm-5 tva-col-md-offset-1 tva-col-md-10"
          :src="`${baseUrl}images/${content.img}${$tvaMq === 'mobile' ? '_m' : ''}.svg`"
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
.tva-viz-paragraph-component {
  margin: 100px 0 50px 0;
  .title {
    font-weight: 800;
    padding: 0;
  }
  .paragraph {
    padding: 0;
  }
  .image-full {
    margin-top: 50px;
  }
}
@media (max-width: 720px) {
  .tva-viz-paragraph-component {
    margin: 50px 0 0 0;
    .column-image {
      display: inline-block;
      width: 100%;
      margin: 30px 17px !important;
      img {
        margin: 0 !important;
        width: 63% !important;
        max-height: 350px;
      }
    }
    .image-full {
      margin-top: 50px !important;
      margin-bottom: 50px;
      padding: 0 !important;
    }
  }
}
</style>


